export default __webpack_public_path__ + "static/media/element_spec_49.b990fd0c.webp";